import { render, staticRenderFns } from "./InvoiceSupplierList.vue?vue&type=template&id=8371b39e&"
import script from "./InvoiceSupplierList.vue?vue&type=script&lang=js&"
export * from "./InvoiceSupplierList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports